import { render, staticRenderFns } from "./choose-step-4.vue?vue&type=template&id=55266594&scoped=true&"
import script from "./choose-step-4.vue?vue&type=script&lang=js&"
export * from "./choose-step-4.vue?vue&type=script&lang=js&"
import style0 from "./choose-step-4.vue?vue&type=style&index=0&id=55266594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55266594",
  null
  
)

export default component.exports